import { styled, theme } from "@theme/stitches.config"
import Button from "@components/Button"

export const GoogleMapsWrapper = styled("div", {
    width: "100%",
    mt: 100,
    position: "relative",
    height: 950,
    maxHeight: "calc(100vh - 200px)",
    "@xxlDown": {
        height: 600
    },
    "@mdDown": {
        height: 500
    },
    "& .gm-style .gm-style-iw-c": {
        borderRadius: 20,
        padding: "22px 16px 8px !important",
        "& button": {
            right: "14px !important",
            top: "14px !important",
            width: "12px !important",
            height: "12px !important",
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L13 13M1 13L13 1L1 13Z' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\") !important",
            backgroundSize: "12px 12px !important",
            backgroundRepeat: "no-repeat !important",
            "& span": {
                display: "none !important"
            }
        }
    }
})

export const InfoWindowContent = styled("div", {
    "& p": {
        fontFamily: theme.fonts.body,
        color: "black",
        margin: 0,
        fontSize: 13,
        lineHeight: 1.65
    }
})

export const Tag = styled("h3", {
    fontFamily: theme.fonts.heading,
    fontSize: 20,
    lineHeight: 1.2,
    textTransform: "uppercase",
    color: "black",
    margin: "0 0 0.75rem"
})

export const Filter = styled("div", {
    position: "absolute",
    top: 16,
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    flexDirection: "row"
})

export const FilterOption = styled(Button, {
    backgroundColor: theme.colors.N900,
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    fontFamily: theme.fonts.heading,
    fontSize: theme.fontSizes.desktopH6,
    color: theme.colors.N50,
    lineHeight: 1,
    textTransform: "uppercase",
    mb: 8,
    py: "6px 8px",
    px: 16,
    borderRadius: 0,
    borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
    "&:first-child": {
        borderLeft: "none",
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4
    },
    "&:last-child": {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4
    },
    variants: {
        active: {
            true: {
                backgroundColor: theme.colors.R500
            }
        }
    }
})
